import axios from "axios";

export const officeApi = axios.create({
  baseURL: process.env.REACT_APP_BASEURL,
  // headers: {
  //   authorization: window.sessionStorage.getItem("accessToken"),
  // },
});

officeApi.interceptors.request.use((config) => {
  const token = window.sessionStorage.getItem("accessToken");
  if (token) {
    config.headers["Authorization"] = token;
  }
  return config;
});

export const commonApi = axios.create({
  baseURL: process.env.REACT_APP_BASEURL,
});
